/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.LogisticsQuotationDetailTobResponseDto>
>;
export function request(
  params: API.tms.logisticsQuotationDetailTob.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsQuotationDetailTob/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
